import React from 'react'
import BookingComponent from 'components/booking/BookingComponent';

function Booking() {
    return (
        <BookingComponent />
    )
}

export default Booking